// extracted by mini-css-extract-plugin
export default {"secondary-column-cell":"secondary-column-cell_RtC5A","secondaryColumnCell":"secondary-column-cell_RtC5A","logo":"logo_cUnrU"};